import * as React from "react"
import {useMemo} from "react"
import {useSignal} from "@preact/signals-react";

import {TextFieldSeeker} from "@ui-seeker/core";

export default function MUIDataTableSearch({ onSearch, onHide, options }) {
	const textSearch = useSignal('')

	const handleHide = () => {
		textSearch.value = ''
		onHide()
	}

	return <TextFieldSeeker
		autoFocus
		variant="standard"
		startIcon="search"
		helperText="Press Enter to search. Escape to finish"
		value={textSearch.value}
		onChange={e => textSearch.value = e.target.value}
		onKeyPress={e => e.key === "Enter" && onSearch(textSearch.value)}
		onKeyUp={e => e.key === "Escape" && handleHide()}
		options={options}
	/>
}
